<template>
  <v-card v-if="course != null">
    <v-card-title>{{course.name}}</v-card-title>
    <v-card-text>
      <div class="mb-5">
        {{course.description}}
        {{course.descriptionHeading}}
      </div>
      <div>
        Schedules ({{scheduleStart}} - {{scheduleEnd}})
        <v-list>
          <v-list-item
            v-for="(event) in course.events"
            :key="event.id"
          >{{formatDate(event.start.dateTime, false)}} to {{formatDate(event.end.dateTime, true)}} {{event.summary}}</v-list-item>
        </v-list>
      </div>

      <v-expansion-panels :popout="true" v-if="sessionCount > 0">
        <v-expansion-panel>
          <v-expansion-panel-header>{{sessionCount}} sessions available</v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-list>
              <v-list-item v-for="(session) in sessions" :key="session.name">{{session.name}}</v-list-item>
            </v-list>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-card-text>
  </v-card>
</template>

<script>
import moment from "moment";

export default {
  data() {
    return {
      course: null
    };
  },
  computed: {
    sessions() {
      return this.course.sessions;
    },
    sessionCount() {
      return this.course.sessions ? this.course.sessions.length : 0;
    },
    scheduleStart(){
      return new moment(this.course.scheduleStart).format("ddd MMM DD, YYYY");
    },
    scheduleEnd(){
      return new moment(this.course.scheduleEnd).format("ddd MMM DD, YYYY");
    }
  },
  methods: {
    async initCourse() {
      const result = await this.$axios
        .get("public/classroom/course", {
          params: { courseId: this.$route.params.id }
        })
        .then(resp => {
          this.course = resp.data;
          this.events = this.course.events;
        })
        .catch(() => {
          this.$store.dispatch(
            "addMessage",
            "Error loading course from server"
          );
        });

      return result;
    },
    formatDate(dataTime, timeOnly) {
      if (timeOnly) {
        return new moment(dataTime.value).format("h:mm a");
      } else {
        return new moment(dataTime.value).format("ddd MMM DD, YYYY h:mm a");
      }
    }
  },
  mounted() {
    this.initCourse();
  }
};
</script>
